import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverlappingEntitiesService {
  private overlappingEntitiesSubject = new Subject<{
    entities: any[];
    position: any;
  }>();
  overlappingEntities$ = this.overlappingEntitiesSubject.asObservable();
  constructor() {}
    showOverlappingEntities(entities: any[], position: any): void {
    this.overlappingEntitiesSubject.next({ entities, position });
  }
  hideOverlappingEntities(): void {
    this.overlappingEntitiesSubject.next({ entities: [], position: null });
  }
}

